import { InjectionToken } from '@angular/core';

export const TranslationInstanceToken = new InjectionToken<TranslationInterface>('TranslationInterface');

export interface TranslationInterface {
    en: {
        [key: string]: string;
    };
    de: {
        [key: string]: string;
    };
}
